/**
 * Drawing Service
 * 
 * Handles drawing creation and management for conversations
 */

import apiClient from '../client';
import { ApiUrls } from '../urls';
import type { DrawingCreationParams, DrawingCreationResponse } from '../../types/drawing.types';

class DrawingService {
  /**
   * Create a drawing from a conversation
   */
  async createDrawing(params: DrawingCreationParams): Promise<DrawingCreationResponse> {
    try {
      const { conversationId, projectId, type } = params;

      let url: string;
      let requestData: any = {};

      // Determine which endpoint to use based on whether we have a project ID
      if (projectId) {
        // Use project conversation drawing endpoint
        url = ApiUrls.projectConversationDrawing(projectId, conversationId);
      } else {
        // Use temporary conversation drawing endpoint
        url = ApiUrls.tmpConversationDrawing(conversationId);
      }

      // Add type to request data if provided
      if (type) {
        requestData.type = type;
      }

      const response = await apiClient.post<DrawingCreationResponse>(url, requestData);
      return response.data;
    } catch (error: any) {
      throw this.handleError(error);
    }
  }

  /**
   * Handle API errors consistently
   */
  private handleError(error: any): Error {
    if (error.response) {
      const message = error.response.data?.message || 'Failed to create drawing';
      return new Error(message);
    }

    // Network error
    return new Error('Network error. Please check your connection.');
  }
}

export const drawingService = new DrawingService();
export default drawingService;
